import { i18nService } from '../services/i18n';
import type { OnlineSkill } from '../types/skill';

const ONLINE_SKILL_TAG_KEYS: Record<string, string> = {
  '文档处理': 'categoryDocuments',
  '搜索资讯': 'categorySearch',
  '网页自动化': 'categoryWebAutomation',
  '通讯协作': 'categoryCommunication',
  '设计创作': 'categoryDesign',
  '效率工具': 'categoryTools',
  '系统增强': 'categorySystem',
  '写作助手': 'categoryWriting',
  '开发集成': 'categoryDev',
};

/**
 * 在线技能名称和摘要均属于发布者提供的技能元数据。
 *
 * 目录标签、按钮和状态由客户端本地化；技能名称、摘要、下载包和安装后的
 * SKILL.md 始终保持服务端原文，避免展示翻译影响审查或用户对技能来源的判断。
 */
export const getLocalizedOnlineSkillSummary = (skill: OnlineSkill): string => {
  return skill.summary;
};

export const getLocalizedOnlineSkillTag = (tag: string): string => {
  const key = ONLINE_SKILL_TAG_KEYS[tag];
  if (!key) return tag;
  const localized = i18nService.t(key);
  return localized === key ? tag : localized;
};
